import { globalDriveFileState, useRetryGlobalDriveFile } from "../api";
import type { GlobalDataRecord } from "../api";
import ds from "../components/DriveSyncSettingsCard.module.css";

// Only on a failed synced file: extracts it again from the copy already synced.
export const GlobalDriveRetryLink = ({
  record,
  className = ds.linkButton,
}: {
  record: GlobalDataRecord | null;
  className?: string;
}) => {
  const retry = useRetryGlobalDriveFile();
  if (record === null || globalDriveFileState(record) !== "failed") return null;
  return (
    <>
      <button
        type="button"
        className={className}
        disabled={retry.isLoading}
        onClick={() => retry.mutate({ global_data_id: record.global_data_id })}
        title="Extract this file again from the copy already synced, with no new fetch from Drive."
      >
        {retry.isLoading ? "Retrying…" : "Retry extraction"}
      </button>
      {retry.isError && (
        <span role="alert" className={ds.error}>
          {retry.error.message || "Retry failed."}
        </span>
      )}
    </>
  );
};
